import { createFileRoute, redirect } from "@tanstack/react-router";
import { AppShell } from "@/components/layout/AppShell";
import { sitzungQuery } from "../auth";

/**
 * Die Schwelle. Alles unterhalb dieser Route verlangt eine gültige Sitzung.
 *
 * Der Unterstrich macht sie zu einer "pathless layout route": Sie taucht in
 * keiner Adresse auf, umschließt aber alles darunter. Neue Seiten kommen nach
 * `routes/_angemeldet/` und sind damit geschützt, ohne dass jemand daran
 * denken muss.
 *
 * Der Guard sitzt in `beforeLoad` und damit **vor** dem Rendern. Eine Prüfung
 * in der Komponente käme zu spät: Die Seite wäre dann schon aufgebaut und
 * hätte ihre Daten schon angefragt.
 *
 * Das ist Bequemlichkeit, kein Schutz. Der Schutz liegt im Backend, wo ohne
 * Sitzung nichts herausgegeben wird. Hier geht es darum, dass niemand auf ein
 * leeres Gerüst mit lauter Fehlermeldungen schaut.
 *
 * Das sichtbare Layout (Sidebar, Kopfzeile, Suche) ist die AppShell aus dem
 * Prototyp — samt Abmelden-Knopf, der die echte Sitzung beendet.
 */
export const Route = createFileRoute("/_angemeldet")({
	beforeLoad: async ({ context, location }) => {
		const sitzung = await context.queryClient.ensureQueryData(sitzungQuery);

		if (sitzung === null) {
			// `location.href` ist hier der Pfad samt Suchparametern, also genau
			// das, wohin der Aufrufer eigentlich wollte.
			throw redirect({ to: "/login", search: { "redirect-to": location.href } });
		}

		// Steht ab hier jeder Route darunter als `context.sitzung` zur Verfügung.
		return { sitzung };
	},
	component: AppShell,
});
